import * as Sentry from '@sentry/react';
import { PropsWithChildren } from 'react';

function SentryWrapper({ children }: PropsWithChildren) {
  if (import.meta.env.VITE_ENVIRONMENT === 'LOCAL') {
    return children;
  }
  return (
    <Sentry.ErrorBoundary
      fallback={<p>Er is een onverwachte fout opgetreden</p>}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
export { SentryWrapper };
